import Deportees from "./Pages/Deportees";
import Portfolio from "./Entities/Portfolio";
import Refuge from "./Pages/Refuge";
import HumanLoss from "./Pages/HumanLoss";
import GamesOfChance from "./Pages/GamesOfChance";
import Retrospection from "./Pages/Retrospection";
import UnnaturalTestimony from "./Pages/UnnaturalTestimony";
import Diplomacy from "./Pages/Diplomacy";
import ForceOfNature from "./Pages/ForceOfNature";
import LotusInTheMud from "./Pages/LotusInTheMud";
import OrderDisorder from "./Pages/OrderDisorder";
import GrassesWild from "./Pages/GrassesWild";
import Witnesses from "./Pages/Witnesses";
import Grasses from "./Pages/Grasses";
import HolyGhosts1 from "./Pages/HolyGhosts1";
import HolyGhosts2 from "./Pages/HolyGhosts2";
import Drawings from "./Pages/Drawings";
import Plankton from "./Pages/Plankton";
import PlanktonSpecies from "./Pages/PlanktonSpecies";
import ValleyOfFire from "./Pages/ValleyOfFireMonotypeCollection";
import DesertMonotypes from "./Pages/DesertMonotypes";
import Pastels from "./Pages/PastelArtwork";
import Nest from "./Pages/Nest";

const portfolios: Portfolio[] = [
    Deportees,
    Refuge,
    HumanLoss,
    GamesOfChance,
    Retrospection,
    UnnaturalTestimony,
    Diplomacy,
    ForceOfNature,
    LotusInTheMud,
    OrderDisorder,
    GrassesWild,
    Witnesses,
    Grasses,
    HolyGhosts1,
    HolyGhosts2,
    Drawings,
    Plankton,
    PlanktonSpecies,
    ValleyOfFire,
    DesertMonotypes,
    Nest,
    Pastels,
];

export default portfolios;